import React, { Dispatch, FC, SetStateAction } from 'react';

import { LoggedInUser } from '../types';
import Identity from 'src/commons/components/Apply/Identity/Identity';
import { Footer } from 'src/commons/components/Footer';
import { Nav } from 'src/commons/components/Nav/Nav';
import { Page } from 'src/commons/components/Page';
import { setIdentityIsVerifyFieldToSessionStorage } from 'src/commons/utilities/identity';

interface IdentityValues {
  dateOfBirth: string;
  last4SSN?: string;
}

interface ApplicationIdentityProps {
  user: LoggedInUser;
  showDOBIdentity: boolean;
  showDOBAndSSNIdentity: boolean;
  showIdentityError: boolean;
  setShowDOBIdentity: Dispatch<SetStateAction<boolean>>;
  setShowDOBAndSSNIdentity: Dispatch<SetStateAction<boolean>>;
  onError: Function;
}

export const ApplicationIdentity: FC<ApplicationIdentityProps> = ({
  user,
  showDOBIdentity,
  showDOBAndSSNIdentity,
  showIdentityError,
  setShowDOBIdentity,
  setShowDOBAndSSNIdentity,
  onError,
}) => {
  const handleIdentityType = (values: IdentityValues) => {
    if (showDOBIdentity) setShowDOBIdentity(false);

    // need to chanage due last 4 digit enhancement
    if (showDOBAndSSNIdentity && values.last4SSN === user.ssn.slice(7)) {
      setShowDOBAndSSNIdentity(false);
    }
  };

  const handleContinue = (values: IdentityValues) => {
    const { dateOfBirth } = values;

    if (dateOfBirth === user.dateOfBirth) {
      handleIdentityType(values);
      setIdentityIsVerifyFieldToSessionStorage(true);
    } else {
      onError();
    }
  };

  return (
    <>
      <Nav />
      <Page>
        <Identity
          isRequireSSNField={showDOBAndSSNIdentity}
          onContinue={handleContinue}
          isIdentityError={showIdentityError}
        />
        <Footer />
      </Page>
    </>
  );
};
